import type { SVGProps } from 'react';
const SvgCreatorWidgetSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#creator-widget-small_svg__a)">
      <path fill="#000" fillOpacity={0.86} d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
      <path
        fill="#fff"
        d="M9.667 3.833H6.333c-1.458 0-2.083.833-2.083 2.083v4.167c0 1.25.625 2.083 2.083 2.083h3.334c1.458 0 2.083-.833 2.083-2.083V5.916c0-1.25-.625-2.083-2.083-2.083m-2.28 6.03c.121.12.121.32 0 .44a.3.3 0 0 1-.22.092.3.3 0 0 1-.221-.091l-.833-.833a.314.314 0 0 1 0-.442l.833-.833c.12-.121.32-.121.442 0 .12.12.12.32 0 .441l-.613.613zm2.5-.392-.833.833a.3.3 0 0 1-.22.091.3.3 0 0 1-.221-.091.314.314 0 0 1 0-.442l.612-.612-.612-.613a.314.314 0 0 1 0-.441c.12-.121.32-.121.441 0l.833.833c.121.12.121.32 0 .442m.821-2.617h-.833a1.145 1.145 0 0 1-1.146-1.146v-.833c0-.171.142-.313.313-.313.17 0 .312.142.312.313v.833c0 .288.234.52.521.52h.833c.171 0 .313.143.313.313 0 .171-.142.313-.313.313"
      />
    </g>
    <defs>
      <clipPath id="creator-widget-small_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCreatorWidgetSmall;
